import { ApplicationStatus } from './application';
import { Application } from './application';
import { Location, LocationFeature } from './location';

export enum ActivityType {
  SPORTS_FITNESS = 'SPORTS_FITNESS',
  SOCIAL = 'SOCIAL',
  LEARNING = 'LEARNING',
  ENTERTAINMENT = 'ENTERTAINMENT',
  TRAVEL = 'TRAVEL',
  WELLNESS = 'WELLNESS',
  OTHER = 'OTHER',
}

export enum ActivityDifficulty {
  BEGINNER = 'Beginner',
  INTERMEDIATE = 'Intermediate',
  ADVANCED = 'Advanced',
}

export const activityTypeColors: Partial<Record<ActivityType, string>> = {
  [ActivityType.SPORTS_FITNESS]: 'bg-green-500',
  [ActivityType.SOCIAL]: 'bg-emerald-500',
  [ActivityType.WELLNESS]: 'bg-pink-500',
  [ActivityType.LEARNING]: 'bg-indigo-500',
  [ActivityType.ENTERTAINMENT]: 'bg-amber-500',
  [ActivityType.TRAVEL]: 'bg-violet-500',
  [ActivityType.OTHER]: 'bg-slate-500',
};

export interface ActivityBase {
  title: string;
  type: ActivityType;
  dateTime: Date;
  
  location?: Location;
  locationId?: string;

  maxParticipants: number;
  description: string;
  difficulty: ActivityDifficulty;
  price: number;
  durationMinutes: number;
  image: string;
}

export interface ActivityFormData extends ActivityBase {
  date?: string;
  time?: string;
  duration?: number;
  creatorId?: string;
  organizerId?: string;

  // new location handling options
  selectedLocationFeature?: LocationFeature;
  locationDisplayName?: string;

  isFree?: boolean;
  creator?: {
    id: string;
    name: string;
    email: string;
  };
}

export interface Activity extends ActivityBase {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  creatorId?: string;
  organizerId?: string;
  participants: number;
  distance?: string;

  // because getActivityById returns the creator object
  // so we could use these to display the creator name on the activity card
  creator?: {
    id: string;
    name: string;
    email: string;
    avatar?: string;
  };

}

export interface ActivityWithApplication extends Activity {
  // this is for coming soon page
  // we need to show the status of the application for the activity
  application?: Application;
}

export const defaultActivityFormData: ActivityFormData = {
  title: '',
  creator: {
    id: '',
    name: '',
    email: '',
  },
  maxParticipants: 0,
  dateTime: new Date(),
  durationMinutes: 60,
  type: ActivityType.SPORTS_FITNESS,
  description: '',
  difficulty: ActivityDifficulty.BEGINNER,
  price: 0,
  // isFree: true,
  image: '',
};
